import { fetchBasicUrlPost, fetchBasicUrlPostJson } from "@/script/common";

export default {
    getGrid: (filter) =>
        fetchBasicUrlPostJson('/DiagnosisDepartment/Grid', {
            asGridData: true,
            data: filter
        }),
    updateDoctor: (wardId, historyCode, doctorCode) =>
        fetchBasicUrlPost('/DiagnosisDepartment/UpdateDoctor', { data: { wardId, historyCode, doctorCode } }),
    layingDepartments: historyCode =>
        fetchBasicUrlPostJson('/DiagnosisDepartment/LayingDepartmentsInHistory', { data: { historyCode } }),
}